// Standalone so `store/commonSlice` can read the enum without importing the Account *page*.
// commonSlice → pages/Account/Account → components/PageTitleBar → store → commonSlice was a real
// import cycle: it left `commonSlice.reducer` undefined at `configureStore` time and crashed any
// Jest suite whose worker happened to load the modules in that order. `import type` cannot fix it —
// the enum is used as a value. `Account.tsx` re-exports this so existing import sites keep working.
export enum AccountSelectMenu {
  AccountSettings,
  PlanBilling,
  ManageMembers,
  Support,
  Integrations,
  Usage,
}

/** `?tab=` on `/account` — a URL-addressable tab, so a full-page redirect (the Miro OAuth round trip) can land on it. */
export const ACCOUNT_TAB_PARAM = "tab";

// Only tabs something has to deep-link to. Every other tab stays reachable by click alone, as before.
const ACCOUNT_TAB_BY_PARAM: Record<string, AccountSelectMenu> = { integrations: AccountSelectMenu.Integrations };

export const ACCOUNT_INTEGRATIONS_PATH = `/account?${ACCOUNT_TAB_PARAM}=integrations`;

/** The tab named by `?tab=`, or `undefined` for a missing / unknown value (the stored tab then stays). */
export const accountMenuFromTabParam = (value: string | null | undefined): AccountSelectMenu | undefined =>
  value && Object.prototype.hasOwnProperty.call(ACCOUNT_TAB_BY_PARAM, value) ? ACCOUNT_TAB_BY_PARAM[value] : undefined;
